(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* Fold the ZIP into contact[tags] at submit (v3 71). If this never runs, the base tags
     still post and the signup succeeds — it just lands in the UNKNOWN zone segment. */
  (function () {
    var form = document.getElementById('ContactFooter');
    if (!form) return;
    var tags = document.getElementById('ContactFooter-tags');
    var zip = document.getElementById('ContactFooter-zip');
    var submit = form.querySelector('.footer__submit');
    form.addEventListener('submit', function () {
      if (tags && zip) {
        var v = (zip.value || '').replace(/[^0-9]/g, '').slice(0, 5);
        tags.value = tags.getAttribute('data-base-tags') + (v.length === 5 ? ', zip:' + v : '');
      }
      if (submit) submit.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && submit) submit.removeAttribute('aria-busy');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-cal-embed"] && !Shopify.designMode) return;
  try {
    
  /* Cal.com official embed loader, then one inline widget per [data-kova-cal] instance. */
  (function (C, A, L) {
    var p = function (a, ar) { a.q.push(ar); };
    var d = C.document;
    C.Cal = C.Cal || function () {
      var cal = C.Cal; var ar = arguments;
      if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement('script')).src = A; cal.loaded = true; }
      if (ar[0] === L) {
        var api = function () { p(api, arguments); };
        var namespace = ar[1];
        api.q = api.q || [];
        if (typeof namespace === 'string') { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ['initNamespace', namespace]); }
        else { p(cal, ar); }
        return;
      }
      p(cal, ar);
    };
  })(window, 'https://app.cal.com/embed/embed.js', 'init');

  (function () {
    var embeds = document.querySelectorAll('[data-kova-cal]');
    if (!embeds.length || typeof window.Cal !== 'function') return;
    /* ON THE DESIGN SYSTEM (Oct 1 2026 night sweep): the widget rendered in Cal's DARK theme (a
       black card on the cream page) because only the ui call asked for light; the theme now also
       goes in the inline config (Cal docs: CSS variables guide). Its colours come from the LIVE
       theme tokens (so the LA sky accent, not the old teal setting): surface booker on cream,
       espresso text, hairline borders, callout for hovered/selected days, controls on the
       12px radius. Variable names: cal.com/docs/developing/guides/embeds/customize-embed-css-variables */
    var css = getComputedStyle(document.documentElement);
    var tok = function (name, fallback) { return (css.getPropertyValue(name) || '').trim() || fallback; };
    var esp = tok('--color-espresso-rgb', '41, 20, 0');
    var light = {
      'cal-brand': tok('--color-teal', el0(embeds).getAttribute('data-cal-brand-light')),
      'cal-brand-emphasis': tok('--color-teal-hover', '#055a6d'),
      'cal-brand-text': tok('--color-cream', '#f5ede0'),
      'cal-bg': tok('--color-surface', '#faf6f0'),
      'cal-bg-muted': tok('--color-cream', '#f5ede0'),
      'cal-bg-subtle': tok('--color-callout', '#f0e4d1'),
      'cal-bg-emphasis': tok('--color-callout', '#f0e4d1'),
      'cal-text': 'rgba(' + esp + ', 0.85)',
      'cal-text-emphasis': tok('--color-espresso', '#291400'),
      'cal-text-subtle': 'rgba(' + esp + ', 0.7)',
      'cal-text-muted': 'rgba(' + esp + ', 0.6)',
      'cal-border': 'rgba(' + esp + ', 0.14)',
      'cal-border-subtle': 'rgba(' + esp + ', 0.1)',
      'cal-border-emphasis': 'rgba(' + esp + ', 0.3)',
      'cal-border-booker': 'rgba(' + esp + ', 0.1)',
      'radius': '12px'
    };
    function el0(list) { return list[0]; }
    embeds.forEach(function (el) {
      var ns = el.getAttribute('data-cal-namespace') || 'chat';
      var layout = el.getAttribute('data-cal-layout') || 'month_view';
      var theme = el.getAttribute('data-cal-theme') || 'light';
      window.Cal('init', ns, { origin: 'https://app.cal.com' });
      window.Cal.ns[ns]('inline', {
        elementOrSelector: '#' + el.id,
        config: { layout: layout, theme: theme },
        calLink: el.getAttribute('data-cal-link') || 'kovakream/chat'
      });
      window.Cal.ns[ns]('ui', {
        theme: theme,
        cssVarsPerTheme: {
          light: light,
          dark: { 'cal-brand': el.getAttribute('data-cal-brand-dark') }
        },
        hideEventTypeDetails: false,
        layout: layout
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-freezer"] && !Shopify.designMode) return;
  try {
    
  /* Kova freezer page: steppers, the checkout bar and checkout. Design + checkout rationale:
     the comment at the top of sections/kova-freezer.liquid. */
  if (!customElements.get('kova-freezer')) {
    const SF_API_VERSION = '2026-07';

    const money = (cents) => {
      const amount = cents / 100;
      return '$' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
    };

    /* Codes stored by Shopify's /discount/CODE endpoint (and the layout's legacy ?discount= links). */
    const cookieCodes = () => {
      const hit = document.cookie.split('; ').find((c) => c.indexOf('discount_code=') === 0);
      if (!hit) return [];
      return decodeURIComponent(hit.slice('discount_code='.length))
        .split(',')
        .map((c) => c.trim())
        .filter(Boolean);
    };

    class KovaFreezer extends HTMLElement {
      connectedCallback() {
        if (this.wired) return;
        const json = this.querySelector('[data-freezer-items]');
        if (!json) return;
        this.wired = true;
        this.items = JSON.parse(json.textContent);
        this.qty = {};
        this.bar = this.querySelector('[data-bar]');
        this.button = this.querySelector('[data-checkout]');
        this.addEventListener('click', (e) => {
          const step = e.target.closest('[data-delta]');
          if (step) this.change(step.closest('[data-variant]').dataset.variant, Number(step.dataset.delta));
        });
        this.button.addEventListener('click', () => this.checkout());
        this.render();
      }

      change(id, delta) {
        const item = this.items[id];
        if (!item || !item.available) return;
        this.qty[id] = Math.min(item.max, Math.max(0, (this.qty[id] || 0) + delta));
        this.render();
      }

      lines() {
        return Object.keys(this.qty)
          .filter((id) => this.qty[id] > 0)
          .map((id) => ({ id, quantity: this.qty[id] }));
      }

      render() {
        /* Totals come from the order, not the cards: one variant can sit in both blocks. */
        let count = 0;
        let total = 0;
        Object.keys(this.qty).forEach((id) => {
          count += this.qty[id];
          total += this.qty[id] * this.items[id].price;
        });
        this.querySelectorAll('[data-variant]').forEach((card) => {
          const id = card.dataset.variant;
          const item = this.items[id];
          const q = this.qty[id] || 0;
          const out = card.querySelector('[data-count]');
          if (!out) return;
          out.textContent = q;
          card.querySelector('[data-delta="-1"]').disabled = q === 0;
          card.querySelector('[data-delta="1"]').disabled = q >= item.max;
          card.toggleAttribute('data-active', q > 0);
        });
        this.bar.toggleAttribute('data-visible', count > 0);
        this.querySelector('[data-bar-count]').textContent = count === 1 ? '1 item' : count + ' items';
        this.querySelector('[data-bar-total]').textContent = count ? money(total) : '';
      }

      /* Returns a checkoutUrl, or null so the caller falls back to the Ajax cart. */
      async storefrontCheckoutUrl() {
        const token = this.dataset.token;
        if (!token) return null;
        const delivery = { deliveryMethod: 'PICK_UP' };
        if (this.dataset.location) delivery.pickupHandle = this.dataset.location;
        const input = {
          lines: this.lines().map((l) => ({ merchandiseId: 'gid://shopify/ProductVariant/' + l.id, quantity: l.quantity })),
          attributes: [{ key: 'Freezer', value: this.dataset.freezer }],
          buyerIdentity: { preferences: { delivery } }
        };
        const codes = cookieCodes();
        if (codes.length) input.discountCodes = codes;
        const query = `mutation CartCreate($input: CartInput!) {
          cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } }
        }`;
        try {
          const res = await fetch('/api/' + SF_API_VERSION + '/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
            body: JSON.stringify({ query, variables: { input } })
          });
          if (!res.ok) return null;
          const result = (await res.json())?.data?.cartCreate;
          if (!result || (result.userErrors && result.userErrors.length)) return null;
          return result.cart?.checkoutUrl || null;
        } catch (e) {
          return null;
        }
      }

      async ajaxCheckout() {
        await fetch('/cart/clear.js', { method: 'POST' });
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: this.lines() })
        });
        if (!res.ok) throw new Error('add failed');
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { Freezer: this.dataset.freezer } })
        });
        window.location.href = '/checkout';
      }

      async checkout() {
        if (!this.lines().length) return;
        const label = this.querySelector('[data-bar-label]');
        this.button.disabled = true;
        label.textContent = 'One moment…';
        try {
          const url = await this.storefrontCheckoutUrl();
          if (url) {
            window.location.href = url;
            return;
          }
          await this.ajaxCheckout();
        } catch (e) {
          label.textContent = 'Try again';
          this.button.disabled = false;
        }
      }
    }

    customElements.define('kova-freezer', KovaFreezer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-links-page"] && !Shopify.designMode) return;
  try {
    
  /* Submit UX: blur + disable + text swap (native POST; captcha-safe, never AJAX).
     bfcache restore resets the button so a Back-nav never shows a stuck "Joining…". */
  (function () {
    var form = document.getElementById('kova-links-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var btn = document.getElementById('kova-links-submit');
      if (btn) {
        btn.textContent = btn.getAttribute('data-label-busy') || 'Joining…';
        btn.disabled = true;
        btn.blur();
      }
    });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var btn = document.getElementById('kova-links-submit');
      if (btn) {
        btn.textContent = btn.getAttribute('data-label-default') || 'Join the list';
        btn.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  /* Playbook motion rule + WCAG 2.2.2: an infinite loop longer than 5s needs a pause mechanism.
     KOVA DELIBERATE DECISION (Sep 30 2026 night, Juan: "hide the play and pause button"): the
     button is no longer VISIBLE — it shows only on keyboard focus — and tapping or clicking the
     strip itself pauses / resumes it. Do not delete the button: hiding the mechanism entirely
     fails WCAG 2.2.2 (hover-pause and prefers-reduced-motion alone do not count). */
  document.addEventListener('click', function (e) {
    var hit = e.target.closest && (e.target.closest('[data-marquee-pause]') || e.target.closest('.kova-marquee__track'));
    if (!hit) return;
    var root = hit.closest('kova-marquee');
    var btn = root && root.querySelector('[data-marquee-pause]');
    if (!btn) return;
    var paused = root.toggleAttribute('data-paused');
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? 'Play logo animation' : 'Pause logo animation');
  });
  /* Reveal hook (v3 DOM contract): adds .is-visible once the strip enters the viewport.
     The strip is fully visible from first paint; the class is available for styling. */
  if (!customElements.get('kova-marquee')) {
    class KovaMarquee extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        var el = this;
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              el.classList.add('is-visible');
              obs.disconnect();
            }
          });
        }, { threshold: 0.1 });
        obs.observe(this);
      }
    }
    customElements.define('kova-marquee', KovaMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-newsletter"] && !Shopify.designMode) return;
  try {
    
  /* Kova newsletter — one static script wires every instance on the page.
     1. Fold the ZIP into contact[tags] at submit (v3 80). If this never runs, the base tags
        still post and the signup succeeds — it just lands in the UNKNOWN zone segment.
     2. aria-busy spinner on the submit button; 3. reset it when restored from bfcache. */
  (function () {
    var sections = document.querySelectorAll('[data-kova-newsletter]');
    if (!sections.length) return;
    sections.forEach(function (root) {
      var form = root.querySelector('form');
      if (!form) return;
      var tags = form.querySelector('input[name="contact[tags]"]');
      var zip = form.querySelector('input[autocomplete="postal-code"]');
      var submit = form.querySelector('button[type="submit"]');
      form.addEventListener('submit', function () {
        if (tags && zip) {
          var base = tags.getAttribute('data-kova-base-tags') || tags.value;
          var v = (zip.value || '').replace(/[^0-9]/g, '').slice(0, 5);
          tags.value = v.length === 5 ? base + ', source:zip-capture, zip:' + v : base;
        }
        if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
        if (submit) submit.setAttribute('aria-busy', 'true');
      });
      window.addEventListener('pageshow', function (e) {
        if (e.persisted && submit) submit.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-starter-pack"] && !Shopify.designMode) return;
  try {
    
  /* ── Buy flow: clear → add both → checkout (v3 behaviour, verbatim) ── */
  (function () {
    var TAG = 'kova-starter-pack';

    function initBundle(el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var btn = el.querySelector('[data-add-bundle]');
      if (!btn) return;
      var textSpan = btn.querySelector('[data-btn-text]');
      var errorEl = el.querySelector('[data-bundle-error]');

      btn.addEventListener('click', function () {
        var variant1Id = btn.dataset.variant1;
        var variant2Id = btn.dataset.variant2;
        if (!variant1Id || !variant2Id) return;

        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        if (errorEl) errorEl.hidden = true;

        // Clear the cart first so previous product page selections
        // don't mix with this starter pack bundle at checkout
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [
                  { id: parseInt(variant1Id, 10), quantity: 1 },
                  { id: parseInt(variant2Id, 10), quantity: 1 }
                ]
              })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            window.location.href = '/checkout';
          })
          .catch(function (error) {
            console.error('Bundle add to cart error:', error);
            if (textSpan) textSpan.textContent = 'Error - try again';
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          });
      });
    }

    if (window.customElements && !customElements.get(TAG)) {
      customElements.define(TAG, class extends HTMLElement {
        connectedCallback() { initBundle(this); }
      });
    }
    document.querySelectorAll(TAG).forEach(initBundle);
  })();

  /* ── FREE-DELIVERY GATE ──────────────────────────────────────────────────────
     Reveals the free-delivery row only when the configured discount code is
     genuinely in the visitor's session.

     Shopify's /discount/CODE endpoint sets a `discount_code` cookie that is NOT
     HttpOnly, so it is readable here. Verified live against kovakream.com on
     Aug 9 2026: hitting /discount/SHIP1?redirect=/pages/starter-pack produced
     `discount_code=SHIP1` in document.cookie.

     Token-exact matching, deliberately: the layout-level multi-code shim joins
     codes with commas (`discount_code=SHIP1,OTHER`), and a substring test would
     let SHIP10 satisfy a SHIP1 gate. Split on comma and compare whole tokens.

     Fails CLOSED. Any error, or no cookie, leaves the row hidden — the safe
     direction is showing nothing rather than promising a price we won't honor.
     ──────────────────────────────────────────────────────────────────────── */
  (function () {
    function readSessionCodes() {
      try {
        var match = document.cookie.split(';').find(function (c) {
          return c.trim().indexOf('discount_code=') === 0;
        });
        if (!match) return [];
        var raw = decodeURIComponent(match.trim().slice('discount_code='.length));
        return raw.split(',').map(function (c) { return c.trim().toUpperCase(); });
      } catch (e) {
        return [];
      }
    }

    function applyGate() {
      var codes = readSessionCodes();
      document.querySelectorAll('[data-kova-delivery-gate]').forEach(function (row) {
        var required = (row.dataset.kovaDeliveryCode || '').trim().toUpperCase();
        var earned = required !== '' && codes.indexOf(required) !== -1;
        if (earned) {
          row.removeAttribute('hidden');
        } else {
          row.setAttribute('hidden', '');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyGate);
    } else {
      applyGate();
    }

    /* Re-run on bfcache restore. A back-button return replays the old DOM, so a
       session that changed in between (code applied, or consumed at checkout)
       would otherwise show a stale row. Same pattern as the capture-form
       spinner reset. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) applyGate();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-customer-addresses]');
    if (!root) return;

    function selectDefault(select, value) {
      if (!value) return;
      for (var i = 0; i < select.options.length; i++) {
        var option = select.options[i];
        if (option.value === value || option.text === value) {
          select.selectedIndex = i;
          return;
        }
      }
    }

    root.querySelectorAll('[data-country-select]').forEach(function (country) {
      var container = document.getElementById(country.dataset.provinceContainer);
      var province = document.getElementById(country.dataset.provinceSelect);
      if (!container || !province) return;

      function fill() {
        var option = country.options[country.selectedIndex];
        var provinces = [];
        try {
          provinces = JSON.parse((option && option.dataset.provinces) || '[]');
        } catch (error) {
          provinces = [];
        }
        province.innerHTML = '';
        if (!provinces.length) {
          container.hidden = true;
          return;
        }
        provinces.forEach(function (pair) {
          var item = document.createElement('option');
          item.value = pair[0];
          item.textContent = pair[1];
          province.appendChild(item);
        });
        container.hidden = false;
        selectDefault(province, province.dataset.default);
      }

      selectDefault(country, country.dataset.default);
      fill();
      country.addEventListener('change', fill);
    });

    root.querySelectorAll('[data-address-delete]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!window.confirm(form.dataset.confirmMessage)) event.preventDefault();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
